export function numberToEuro(cents) {
  return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(cents)
}
